import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { boxContainer, Buttons, Spacer, meeting } from "../../components";
import { Images } from "../../config";

const MeetingTopPart = () => {
  const { meetingsAll } = useSelector((state) => state.meeting);

  const upperBoxes = [
    {
      value: meetingsAll?.meetingsToday ?? 0,
      text: "Meetings Today",
      icon: Images.MeetingsToday,
    },
    {
      value: meetingsAll?.meetingsThisWeek ?? 0,
      text: "Meetings This Week",
      icon: Images.MeetingsThisWeek,
    },
    {
      value: meetingsAll?.upcomingMeetings ?? 0,
      text: "Up Coming Meetings",
      icon: Images.MeetingsUpcoming,
    },
  ];

  return (
    <div>
      <div className="grid grid-cols-3 gap-[2.5em] items-center">
        {upperBoxes?.map((item, index) => (
          <boxContainer.LiteBoxContainer bg="bg-liteBoxBg" key={index}>
            <div className="flex justify-between items-center">
              <div>
                <div className="header-md">{item?.text}</div>
                <div className="header-xl">{item?.value}</div>
              </div>
              <div>
                <img src={item?.icon} />
              </div>
            </div>
          </boxContainer.LiteBoxContainer>
        ))}
      </div>
      <Spacer height={25} />
      <div className="flex justify-between items-center">
        <div className="header-md">Meetings</div>
        <Link to={"/meetings/add-meeting"}>
          <Buttons.DefaultButton width="max" size="medium">
            New Meeting
          </Buttons.DefaultButton>
        </Link>
      </div>
      <Spacer height={15} />
      <meeting.MeetingTabs />
    </div>
  );
};

export default MeetingTopPart;
